<template>
  <main>
    <router-view />
  </main>

  <footer>
    <div class="p-d-flex p-jc-between">
      <div class="p-flex-column">
        <p class="p-m-0">© {{ copyrightYear }}</p>
        <p class="footer-secondary p-m-0">All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRootStore } from "@/stores/issuer";

export default defineComponent({
  name: "ProductHistoryApp",
  setup: () => {
    return { rootStore: useRootStore() };
  },
  data() {
    return {
      copyrightYear: new Date().getUTCFullYear(),
    };
  },

  async created() {
    await this.rootStore.init();
  },
});
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 0 2%;
  max-width: 1500px;
  margin: 0 auto;
}
main {
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
  padding-bottom: 6rem;
}
</style>
